import React from 'react';
import Icon from '../../../../components/AppIcon';
import Image from '../../../../components/AppImage';
import Button from '../../../../components/ui/Button';

const RecommendedCourses = ({ courses }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="BookOpen" size={20} color="var(--color-accent)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Recommended Courses
        </h3>
      </div>
      <div className="space-y-4">
        {courses?.map((course) => (
          <div 
            key={course?.id}
            className="border border-border rounded-lg overflow-hidden hover:shadow-elevation-2 transition-all duration-150 ease-out"
          >
            <div className="relative h-40 overflow-hidden bg-muted">
              <Image 
                src={course?.thumbnail}
                alt={course?.thumbnailAlt}
                className="w-full h-full object-cover"
              />
              {course?.badge && (
                <div className="absolute top-3 right-3 px-3 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
                  {course?.badge}
                </div>
              )}
            </div>

            <div className="p-4 space-y-3">
              <div>
                <h4 className="text-base font-heading font-semibold text-foreground mb-1">
                  {course?.title}
                </h4>
                <p className="text-sm text-muted-foreground line-clamp-2">
                  {course?.description}
                </p>
              </div>

              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
                  <span>{course?.duration}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Users" size={14} color="var(--color-muted-foreground)" />
                  <span>{course?.students}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Star" size={14} color="var(--color-warning)" />
                  <span>{course?.rating}</span>
                </div>
              </div>

              <div className="flex items-center justify-between pt-2">
                <span className="text-lg font-heading font-bold text-primary">
                  ${course?.price}
                </span>
                <Button 
                  variant="default" 
                  size="sm"
                  iconName="ArrowRight"
                  iconPosition="right"
                >
                  Enroll Now
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendedCourses;